import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IHTTPResponse } from '../../../core-lib/interfaces/http-response';
import {
  CorporateInteractionRateFilters,
  CorporateInteractionTrendsFilters,
  InteractionRateByOriginResponse,
  InteractionRateFilters,
  InteractionRateResponse,
  InteractionRateTrendsResponse,
  TrendingTopicsFilters,
} from '../../models/Summary.model';

@Injectable({
  providedIn: 'root',
})
export class ConciergeSummaryService {
  private readonly interactionRatePath = `${environment.conciergePath}external/corporate/interaction-rate`;

  constructor(private http: HttpClient) {}

  getInteractionRate(filters: CorporateInteractionRateFilters): Observable<InteractionRateResponse> {
    const params = new HttpParams()
      .set('customers_ids', filters.customers_ids)
      .set('start_date', filters.start_date)
      .set('end_date', filters.end_date);

    return this.http.get<InteractionRateResponse>(this.interactionRatePath, { params });
  }

  getInteractionRateByOrigin(filters: CorporateInteractionRateFilters): Observable<InteractionRateByOriginResponse> {
    const params = new HttpParams()
      .set('customers_ids', filters.customers_ids)
      .set('start_date', filters.start_date)
      .set('end_date', filters.end_date);

    return this.http.get<InteractionRateByOriginResponse>(`${this.interactionRatePath}/by-origin`, { params });
  }

  getInteractionRateTrends(filters: CorporateInteractionTrendsFilters): Observable<InteractionRateTrendsResponse> {
    const params = new HttpParams()
      .set('customers_ids', filters.customers_ids)
      .set('start_date', filters.start_date)
      .set('end_date', filters.end_date)
      .set('segmented_by', filters.segmented_by);

    return this.http.get<InteractionRateTrendsResponse>(`${this.interactionRatePath}/trends`, { params });
  }

  getTimeSaved(filters: InteractionRateFilters): Observable<IHTTPResponse> {
    const url = `${environment.conciergePath}customers/concierge/time-savings`;

    const params = new HttpParams()
      .set('customer_ids', filters.customer_ids)
      .set('start_date', filters.start_date)
      .set('end_date', filters.end_date);

    return this.http.get<IHTTPResponse>(url, { params });
  }

  getAutomationRate(filters: InteractionRateFilters): Observable<IHTTPResponse> {
    const url = `${environment.conciergePath}customers/messages/human-derivation-stats`;

    const params = new HttpParams()
      .set('customer_ids', filters.customer_ids)
      .set('start_date', filters.start_date)
      .set('end_date', filters.end_date);

    return this.http.get<IHTTPResponse>(url, { params });
  }

  getTrendingTopics(filters: TrendingTopicsFilters): Observable<IHTTPResponse> {
    const url = `${environment.conciergePath}conversations/trending-topics`;
    const page = 0;
    const size = 10;

    const params = new HttpParams()
      .set('customer_id', filters.customer_id)
      .set('start_date', filters.start_date)
      .set('end_date', filters.end_date)
      .set('page', page)
      .set('size', size);

    return this.http.get<IHTTPResponse>(url, { params });
  }
}
